import type Team from '~/types/teams/team'

interface TeamState {
  selected: Team | undefined
  chosen: string | undefined
  teams: Team[]
}

export const useTeamsStore = () => {
  const { create, get, getAll } = useTeamsApi()

  let cancel = () => {}

  return defineStore('team', {
    state: (): TeamState => {
      return {
        selected: undefined,
        chosen: undefined,
        teams: [],
      }
    },
    persist: {
      pick: ['chosen'],
    },
    actions: {
      async create(name: string) {
        cancel()
        const team = await create(name)
        this.selected = team
        this.teams.push(team)

        const { start, stop } = useInterval(async () => {
          this.selected = await this.get()
        }, 10000)
        start()
        cancel = stop
      },
      async get() {
        if (!this.selected) {
          return
        }
        return await get(this.selected.id)
      },
      async getAll() {
        this.teams = await getAll()
        if (this.chosen !== undefined) {
          this.teams.forEach((t) => {
            if (this.chosen == t.id) {
              this.selected = t
            }
          })
        }
      },
    },
  })()
}
